import boardJson from './data/board.json';
import type { Board } from './types';

/** The default Scotland Yard board (~199 stations across taxi/bus/underground/ferry edges). */
export const SY_BOARD: Board = boardJson as Board;
